import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { DanceRoles } from '../../../pure-js/types/GrooverTypes'
import { CourseRegistrationFormValues } from '../helpers/CourseRegistrationStepOneHelper'
import { DiscountPricingConfig } from '../../../pure-js/types/DiscountTypes'
import { getComplementaryDanceRole } from '../helpers/RegistrationRoleHelper'

const usePartnerAndRoles = (
  onSetDiscountType: (discountType: DiscountPricingConfig['registrationType']) => void,
  role: DanceRoles | null,
  partnerRole: DanceRoles | null,
  onSetRole: (role: DanceRoles | null) => void,
  onSetPartnerRole: (partnerRole: DanceRoles | null) => void
) => {
  const [hasPartner, setHasPartner] = useState(false)

  // Selecting one half of a couple derives the other half, unless either side is Both
  // (a deliberate "either" the pairing must not overwrite) or the new role has no complement.
  const changeRole = (isPartnerRole: boolean, newRole: DanceRoles) => {
    const setSelectedRole = isPartnerRole ? onSetPartnerRole : onSetRole
    const setDerivedRole = isPartnerRole ? onSetRole : onSetPartnerRole
    const currentDerivedRole = isPartnerRole ? role : partnerRole
    const complementaryRole = getComplementaryDanceRole(newRole)

    setSelectedRole(newRole)
    if (!complementaryRole || currentDerivedRole === DanceRoles.Both) return
    setDerivedRole(complementaryRole)
  }

  const handleRemovePartner = (
    formProps: UseFormReturn<CourseRegistrationFormValues, any, CourseRegistrationFormValues>
  ) => {
    setHasPartner(false)
    const fieldsToReset = {
      partnerName: '',
      partnerPhoneNumber: '',
      partnerEmail: '',
      partnerRole: DanceRoles.Follower
    }
    Object.entries(fieldsToReset).forEach(([field, value]) => {
      formProps.setValue(field as keyof CourseRegistrationFormValues, value)
      formProps.clearErrors(field as keyof CourseRegistrationFormValues)
    })
    // Clear rather than default to Follower: the partner is gone, and DEFAULT_STATE models
    // "no role chosen" as null. A concrete value here would survive a remove-then-re-add and
    // satisfy the partner-role guards without the user ever picking, letting a Follower/Follower
    // couple through — and it contradicts the spec's "role selection starts unset".
    onSetPartnerRole(null)
    // reset discount type
    onSetDiscountType('single')
  }

  return { hasPartner, setHasPartner, role, partnerRole, changeRole, handleRemovePartner }
}

export default usePartnerAndRoles
